import { useEffect } from 'react';
import * as React from 'react';
import { isMobile } from 'react-device-detect';
import toast, { Toaster as ToastComponent } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

import { defaultTheme } from '@/utility/theme';

const Toaster: React.FC = () => {
  const location = useLocation();

  // パスが変わるとトーストは消える処理
  useEffect(() => {
    toast.dismiss();
  }, [location.pathname]);

  return (
    <ToastComponent
      position={isMobile ? 'top-center' : 'bottom-right'}
      containerStyle={{ marginBottom: '30px' }}
      toastOptions={{
        style: {
          color: defaultTheme.color.white,
          fontSize: defaultTheme.font.size.s,
        },
        error: {
          iconTheme: {
            primary: defaultTheme.color.white,
            secondary: defaultTheme.color.error,
          },
          style: {
            backgroundColor: defaultTheme.color.error,
          },
        },
        success: {
          iconTheme: {
            primary: defaultTheme.color.white,
            secondary: defaultTheme.color.success,
          },
          style: {
            backgroundColor: defaultTheme.color.success,
          },
        },
      }}
    />
  );
};

export default Toaster;
